<template>
  <div class="stand-preloader__img">
    <svg width="92" height="78" viewBox="0 0 92 78" fill="none" xmlns="http://www.w3.org/2000/svg" style="
    color: #355695;
">
      <g opacity="0.5">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M83.1838 50.1579C78.4773 66.2477 63.6111 78.0001 46 78.0001C24.6063 78.0001 7.26318 60.657 7.26318 39.2632C7.26318 17.8694 24.6063 0.526367 46 0.526367C65.2948 0.526367 81.2947 14.6332 84.2486 33.0957L78.0789 24.7368L72.8401 31.8346C69.5896 20.0643 58.8042 11.4211 46 11.4211C30.6232 11.4211 18.1579 23.8864 18.1579 39.2632C18.1579 54.6399 30.6232 67.1053 46 67.1053C57.5105 67.1053 67.3896 60.1203 71.6298 50.1579H83.1838Z"
              fill="#355695"></path>
        <path d="M64.158 47.737L78.079 29.5791L92.0001 47.737H64.158Z" fill="#355695"></path>
      </g>
    </svg>

  </div>
</template>

<script>
  export default {
    name: "Loader"
  }
</script>

<style scoped>
  .stand-preloader__img {
    overflow: hidden;
  }

  .stand-preloader__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 11111;
    text-align: center;
    margin: 0 auto 20px
  }

  .stand-preloader__img svg {
    max-width: 100%;
    -webkit-animation: rotate 1s linear infinite;
    animation: rotate 1s linear infinite
  }

  @-webkit-keyframes rotate {
    from {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg)
    }
  }

  @keyframes rotate {
    from {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg)
    }
  }
</style>